module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/GY-7b7850fc67a7e3fde9ca4547093e7a2b.png";